export interface SelectedImage {
  id: string;
  imageUrl: string;
  token?: string;
}

export interface ImageState {
  images: SelectedImage[];
  imagesError?: string;
}

export const ImageInitialState: ImageState = {
  images: [],
  imagesError: ''
};

export type ImageAction =
  | { type: 'addImage'; value: SelectedImage }
  | { type: 'removeImage'; value: SelectedImage }
  | { type: 'replaceImage'; value: SelectedImage }
  | { type: 'imagesError'; value: string };

export const imagesReducer = <T extends ImageState>(state: T, action: ImageAction): T => {
  switch (action.type) {
    case 'addImage':
      return { ...state, images: [...state.images, action.value] };
    case 'removeImage': {
      return {
        ...state,
        images: state.images.filter(img => img.id !== action.value.id)
      };
    }
    case 'replaceImage': {
      return {
        ...state,
        images: state.images.map(img =>
          img.id === action.value.id
            ? { ...img, imageUrl: action.value.imageUrl, token: action.value.token }
            : img
        )
      };
    }
    case 'imagesError':
      return { ...state, imagesError: action.value };
    default:
      return state;
  }
};

export const addImage = (
  id: string,
  imageUrl: string,
  dispatch: (action: ImageAction) => void,
  token?: string
) => {
  dispatch({ type: 'addImage', value: { id, imageUrl, token } });
  dispatch({ type: 'imagesError', value: '' });
};

export const removeImage = (
  id: string,
  imageUrl: string,
  dispatch: (action: ImageAction) => void
) => {
  dispatch({ type: 'removeImage', value: { id, imageUrl } });
  dispatch({ type: 'imagesError', value: '' });
};

export const replaceImage = (
  id: string,
  imageUrl: string,
  dispatch: (action: ImageAction) => void,
  token?: string
) => {
  dispatch({ type: 'replaceImage', value: { id, imageUrl, token } });
  dispatch({ type: 'imagesError', value: '' });
};
